import React, {ReactElement} from "react";
import {Checkbox, Divider, Select, SelectProps, Tag, Tooltip} from "antd";
import "./index.scss"
import {CloseOutlined, InfoCircleFilled, PushpinFilled} from "@ant-design/icons";

const {Option} = Select;

type props = {
    placeHolder: string
    options: Array<string>
    selected: Array<string>
    onSelected: SelectProps["onChange"]
    containerId: string
    pinned: Array<string> | null
    getPopupContainer?: (triggerNode: Node) => HTMLElement
}

export const MultiSelect = ({placeHolder, options, selected, onSelected, containerId, pinned, getPopupContainer}: props) => {
        const restOptions: SelectProps = {};
        if (containerId !== undefined) {
            restOptions.getPopupContainer = () => document.getElementById(containerId)!!;
        } else if(getPopupContainer) {
          restOptions.getPopupContainer = getPopupContainer
        }
        return (
            <div className="column-select-container">
                <div className="column-select-display-label">Display Columns:</div>
                <Select
                    mode="multiple"
                    className="column-select"
                    style={{width: "100%", marginTop: "4px", marginLeft: "-8px"}}
                    placeholder={placeHolder}
                    onChange={onSelected}
                    value={selected}
                    size={"small"}
                    maxTagCount={"responsive"}
                    menuItemSelectedIcon={({_isSelected}) => {
                        return null
                    }}
                    {...restOptions}
                    tagRender={({value, onClose}) => {
                        return (<Tag>{value} <CloseOutlined onClick={onClose}/></Tag>)
                    }}
                    dropdownRender={(selectableOptions: ReactElement) => {
                        return (
                            <div className="column-select-popup">
                                {
                                    (pinned !== null && pinned.length > 0) ?
                                        <div className="pinned-columns">
                                            <div className="heading">
                                                Default pinned columns
                                                <Tooltip
                                                    title="Columns are pinned by default and cannot be moved. Please use the horizontal scroll to scroll through the columns"
                                                    placement="top"
                                                >
                                                    <InfoCircleFilled
                                                        style={{
                                                            fontSize: "16px",
                                                            color: "#000000",
                                                            paddingLeft: "12px",
                                                            cursor: "pointer",
                                                            strokeWidth: "30"
                                                        }}
                                                    />
                                                </Tooltip>
                                            </div>
                                            {pinned.map((pinnedValue) => {
                                                return (
                                                    <div className="pinned-column" key={pinnedValue}>
                                                        <PushpinFilled
                                                            style={{
                                                                fontSize: "18px",
                                                                color: "#000000"
                                                            }}
                                                            aria-label={"pin"}
                                                        />
                                                        {pinnedValue}
                                                    </div>
                                                )
                                            })}
                                            <Divider/>
                                        </div>
                                        : null}
                                {selectableOptions}
                            </div>
                        )
                    }
                    }
                >
                    {options.map((option) => (
                        <Option
                            key={option}
                            value={option}
                        >
                            <Checkbox checked={selected.some((selectedValue) => option === selectedValue)}/>
                            {option}
                        </Option>
                    ))}
                </Select>
            </div>
        )
            ;
    }
;
